module.exports = __webpack_public_path__ + "static/inspect-element-a3652f985efecbee72772ca06f4fef02.gif";